import { Http } from '../../http'

export class ReferenceQuestion {
  constructor (elm) {
    this.elm = elm;
    this.answers = this.elm.querySelectorAll('button');
    this.answerElm = this.elm.querySelector('.js-reference-answer-buttons');
    this.resultElm = this.elm.querySelector('.js-reference-answer-results');

    this.answers.forEach((a) => {
      a.addEventListener('click', e => this.onButtonClick(e), false);
    });
  }

  onButtonClick (e) {
    const params = {
      post_id: this.elm.dataset.postId,
      reference_question_id: this.elm.dataset.referenceQuestionId,
      reference_answer_id: e.currentTarget.dataset.referenceAnswerId,
    }

    Http.post('/api/post_reference_answers', params)
      .then(response => {
        const content = response.data.result_html;
        this.resultElm.innerHTML = content;
        this.answerElm.style.display = 'none';
        this.resultElm.style.display = 'block';
      })
  }
}
